/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface LakeUser {
  id?: number;
  login?: string;
  role?: LakeUser.RoleEnum;
  enabled2FA?: boolean;
  active?: boolean;
  accountId?: number;
  forceToResetPassword?: boolean;
  firstName?: string;
  lastName?: string;
  subRole?: LakeUser.SubRoleEnum;
  lastPasswordChange?: string;
}
export namespace LakeUser {
  export const RoleEnum = {
    Admin: 'ADMIN',
    Client: 'CLIENT',
    ClientApiKey: 'CLIENT_API_KEY',
    AdminRead: 'ADMIN_READ',
    SuperAdmin: 'SUPER_ADMIN',
    AdminCompliance: 'ADMIN_COMPLIANCE',
  } as const;
  export type RoleEnum = (typeof RoleEnum)[keyof typeof RoleEnum];
  export const SubRoleEnum = {
    ReadOnly: 'READ_ONLY',
    Trader: 'TRADER',
    TraderPro: 'TRADER_PRO',
  } as const;
  export type SubRoleEnum = (typeof SubRoleEnum)[keyof typeof SubRoleEnum];
}
